import React from "react";

import { CustomSwitch } from "src/app/components/CustomSwitch/CustomSwitch";
import {
  MetaFieldIcon,
  renderTooltipIcon,
} from "src/app/modals/ManageFieldModal/components/GlobalFields/utils";
import { ReactComponent as GridIcon } from "src/images/grid.svg";
import { ReactComponent as TrashCanIcon } from "src/images/trash-can-gray.svg";
import {
  GlobalProjectMetaField,
  GlobalTaskMetaField,
} from "src/redux/settings/settingsReducer";
import useSortableItem from "src/app/components/VerticalDragAndDropList/useSortableItem";
import {
  FieldOption,
  HandleRemoveFieldsProps,
  HandleUpdateTemplateValueParams,
  TemplateProjectField,
  TemplateTaskField,
} from "../types";
import { TaskType } from "src/types";

interface DraggableFieldListItemProps {
  option: FieldOption;
  globalField: GlobalProjectMetaField | GlobalTaskMetaField;
  templateField: TemplateProjectField | TemplateTaskField;
  handleUpdateTemplateValue: (params: HandleUpdateTemplateValueParams) => void;
  handleRemoveFields: (params: HandleRemoveFieldsProps) => void;
  fieldType: "project" | "task";
  taskType: TaskType;
}

export default function DraggableFieldListItem({
  option,
  globalField,
  templateField,
  handleUpdateTemplateValue,
  handleRemoveFields,
  fieldType,
  taskType,
}: DraggableFieldListItemProps) {
  const { attributes, listeners, setNodeRef, style } = useSortableItem(
    option.value,
  );

  return (
    <li
      ref={setNodeRef}
      style={style}
      className="template-manager__list-item grid--fields"
      data-qa-field-name={option.label}
    >
      <div className="template-manager__text">
        <div {...attributes} {...listeners} className="icon-drag">
          <GridIcon />
        </div>

        <div className="template-manager__name">
          <MetaFieldIcon
            icon={renderTooltipIcon(globalField.type, globalField.valueSource)}
          />
          <span className="template-manager__name-text">
            {globalField.name}
          </span>
        </div>
      </div>
      <div className="template-manager__list-actions">
        <CustomSwitch
          checked={templateField.hide}
          onChange={(e) => {
            handleUpdateTemplateValue({
              uuid: templateField.uuid,
              valueFieldName: "hide",
              updatedValue: e.target.checked,
              fieldType,
              taskType,
            });
          }}
        />
        <button
          aria-label="Remove field"
          type="button"
          className="button-style-reset"
          onClick={() =>
            handleRemoveFields({
              fieldsToRemove: [templateField.uuid],
              fieldType,
              taskType,
            })
          }
        >
          <TrashCanIcon />
        </button>
      </div>
    </li>
  );
}
